<form [formGroup]="requestForm" (ngSubmit)="onSubmit()" class="space-y-4 rounded-xl px-12 py-4 shadow-2xl">
  <!-- PHARMACY INFO -->
  <div class="mb-8">
    <!-- <h2 class="mb-4 text-2xl font-semibold text-[#C42727]" i18n="@@pharmacyInfo">Pharmacy Information</h2> -->
    <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
      <app-pharamcy-nickname [pharmacyForm]="requestForm" />
      <app-pharmacist-national-id [pharmacyForm]="requestForm" />
      <app-commercial-registeration-number [pharmacyForm]="requestForm" />
      <app-tax-identification-number [pharmacyForm]="requestForm" />
    </div>
  </div>

  <!-- PHARMACY DOCS -->
  <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
    <app-commercial-regestration-image
      [pharmacyForm]="requestForm"
      (uploadSuccess)="onFileUploaded($event, 'commercialRegistrationFid')" />

    <app-tax-image
      [pharmacyForm]="requestForm"
      (uploadSuccess)="onFileUploaded($event, 'taxRegistrationCertificateFid')" />

    <app-pharmacy-contract-image
      [pharmacyForm]="requestForm"
      (uploadSuccess)="onFileUploaded($event, 'pharmacyContractFid')" />

    <app-national-id-card
      [pharmacyForm]="requestForm"
      (uploadSuccess)="onFileUploaded($event, 'pharmacistNationalIdFid')" />

    <app-pharmacy-license-image
      [pharmacyForm]="requestForm"
      (uploadSuccess)="onFileUploaded($event, 'pharmacyLicenseFid')" />
  </div>

  <!-- DETAILED ADDRESS -->
  <div class="space-y-4">
    <h2 class="text-primary mb-4 text-2xl font-semibold" i18n="@@detailedAddress">Detailed Address</h2>
    <app-pharmacy-address [pharmacyForm]="requestForm" />

    <div class="mt-4">
      <app-pharmacy-location [pharmacyForm]="requestForm" />
    </div>
  </div>

  @if (submissionError() || errorEditPharamcy()) {
    <div class="my-4 w-full">
      <app-error [apiError]="submissionError() ? submissionError() : errorEditPharamcy()" />
    </div>
  }

  <div class="flex justify-end gap-3">
    <button
      type="button"
      (click)="onCancel()"
      class="border-primary text-primary hover-bg-primary-10 rounded-[6px] border px-5 py-1.5 text-[13px] font-[500] hover:cursor-pointer"
      i18n="@@pharmacyFormCancelButton">
      Cancel
    </button>
    <button
      type="submit"
      [disabled]="loading()"
      [class]="
        'bg-primary hover-bg-primary-hover rounded-[6px] px-5 py-1.5 text-[13px] font-[500] text-white hover:cursor-pointer ' +
        (loading() ? 'cursor-not-allowed opacity-50' : '')
      ">
      @if (loading()) {
        <span i18n="@@loading">Submitting...</span>
      } @else {
        @if (type() === "create") {
          <span i18n="@@pharmacyFormSubmitButton">Submit Request</span>
        }
        @if (type() === "edit") {
          <span i18n="@@submitModificationTitle">Submit Modifications</span>
        }
      }
    </button>
  </div>
</form>

@if (isNotificationVisible()) {
  <app-successful-notification
    [type]="'success'"
    [title]="
      type() === 'create'
        ? isArabic()
          ? 'تم تسجيل الصيدلية بنجاح'
          : 'Pharamcy Registrated Successfully'
        : isArabic()
          ? 'تم إرسال التعديلات بنجاح. تم تحديث حالة الطلب إلى قيد المراجعة.'
          : 'Modifications submitted successfully. Request status updated to In Progress.'
    " />
}
